angular
  .module('app')
  .config(($translateProvider) => {
    $translateProvider.useStaticFilesLoader({
      prefix: 'static/l10n/',
      suffix: '.json',
    });
    $translateProvider.useSanitizeValueStrategy('escape');
    $translateProvider.registerAvailableLanguageKeys(['en', 'ko', 'ja', 'th'], {
      'ko_*': 'ko',
      'en_*': 'en',
      'ja_*': 'ja',
      'th_*': 'th',
    }).fallbackLanguage(['en']);
    $translateProvider.determinePreferredLanguage();
  });

// Load Maps via angular-google-maps (callback) — do not use a separate async <script>.
angular
  .module('app')
  .config(['uiGmapGoogleMapApiProvider', function (uiGmapGoogleMapApiProvider) {
    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyDT3epJB8HpYxVCB8GJyeuBEhaV8HjpUR4',
      v: 'weekly',
      libraries: 'geometry,drawing',
    });
  }]);

angular
  .module('app')
  .config(['$locationProvider', '$routeProvider',
    function config($locationProvider, $routeProvider) {
      $routeProvider
        .when('/service/goods', {
          template: '<goods-list></goods-list>',
        })
        .when('/service/goods/add', {
          template: '<goods-add></goods-add>',
        })
        .when('/service/options', {
          template: '<options-list></options-list>',
        })
        .when('/service/options/add', {
          template: '<options-add></options-add>',
        })
        .when('/push/notification', {
          template: '<push-notification></push-notification>',
        })
        .when('/orders/search', {
          template: '<orders-search></orders-search>',
        })
        .when('/orders/wait', {
          template: '<orders-wait></orders-wait>',
        })
        .when('/orders/rates', {
          template: '<orders-rates></orders-rates>',
        })
        .when('/orders/subscription', {
          template: '<orders-subscript></orders-subscript>',
        })
        .when('/orders/subscription_package', {
          template: '<orders-search></orders-search>',
        })
        .when('/subscription/orders/add', {
          template: '<orders-subscription-add></orders-subscription-add>',
        })
        .when('/balance/bm/point', {
          template: '<balance-bm-point></balance-bm-point>',
        })
        .when('/balance/download', {
          template: '<balance-download></balance-download>',
        })
        .when('/subscription/product', {
          template: '<subscription-product></subscription-product>',
        })
        .when('/subscription/product/add', {
          template: '<subscription-product-add></subscription-product-add>',
        })
        .when('/service/subscription-package', {
          template: '<subscription-package></subscription-package>',
        })
        .when('/sentences', {
          template: '<sentences></sentences>',
        })
        .when('/washes/count', {
          template: '<washes-count></washes-count>',
        })
        .when('/washes/dashboard', {
          template: '<washes-dashboard></washes-dashboard>',
        })
        .when('/washes/revenue', {
          template: '<washes-revenue></washes-revenue>',
        })
        .when('/washes/revenue/:month', {
          template: '<washes-revenue-detail></washes-revenue-detail>',
        })
        .when('/blacklist', {
          template: '<blacklist></blacklist>',
        })
        .when('/blacklist/add', {
          template: '<blacklist-add></blacklist-add>',
        })
        .when('/affiliate/company', {
          template: '<affiliate-company></affiliate-company>',
        })
        .when('/affiliate/company/add', {
          template: '<affiliate-company-add></affiliate-company-add>',
        })
        .when('/percent/coupons', {
          template: '<percent-coupons></percent-coupons>',
        })
        .when('/percent/coupons/add', {
          template: '<percent-coupons-add></percent-coupons-add>',
        })
        .when('/member/whitelist', {
          template: '<member-whitelist></member-whitelist>',
        })
        .when('/member/:user_id/', {
          template: '<member-edit></member-edit>',
        })
        .when('/member/car/add', {
          template: '<member-car-add></member-car-add>',
        })
        .when('/affiliate/user', {
          template: '<affiliate-user></affiliate-user>',
        })
        .when('/service/setting', {
          template: '<setting></setting>',
        })
        .when('/service/banners', {
          template: '<banners></banners>',
        })
        .when('/service/auto-product', {
          template: '<auto-product></auto-product>',
        })
        .when('/service/apps', {
          template: '<apps></apps>',
        })
        .when('/app-setting/transportation', {
          template: '<app-setting-transportation></app-setting-transportation>',
        })
        .when('/app-setting/invite-coupon', {
          template: '<app-setting-invite-coupon></app-setting-invite-coupon>',
        })
        .when('/app-setting/welcome', {
          template: '<app-setting-welcome></app-setting-welcome>',
        })
        .when('/app-setting/tutorial', {
          template: '<app-setting-tutorial></app-setting-tutorial>',
        })
        .when('/app-setting/order-tutorial', {
          template: '<app-setting-order-tutorial></app-setting-order-tutorial>',
        })
        .when('/service/area', {
          template: '<service-area></service-area>',
        })
        .when('/promotion/code', {
          template: '<promotion-code></promotion-code>',
        })
        .when('/promotion/code/add', {
          template: '<promotion-code-add></promotion-code-add>',
        })
        .when('/event/code', {
          template: '<event-code></event-code>',
        })
        .when('/event/code/:tb_event_code_id/users', {
          template: '<eventcode-users></eventcode-users>',
        })
        .when('/inhouse/notice', {
          template: '<inhouse-notice-list></inhouse-notice-list>',
        })
        .when('/inhouse/notice/add', {
          template: '<inhouse-notice-add></inhouse-notice-add>',
        })
        .when('/inhouse/notice/edit', {
          template: '<inhouse-notice-edit></inhouse-notice-edit>',
        })
        .when('/inhouse/notice/view', {
          template: '<inhouse-notice-view></inhouse-notice-view>',
        })
        .when('/stat/wash/byarea', {
          template: '<stat-wash-byarea></stat-wash-byarea>',
        })
        .when('/stat/wash', {
          template: '<stat-wash></stat-wash>',
        })
        .when('/stat/wdressroom', {
          template: '<stat-wdressroom></stat-wdressroom>',
        })
        .when('/stat/member', {
          template: '<stat-member></stat-member>',
        })
        .when('/stat/employee', {
          template: '<stat-employee></stat-employee>',
        })
        .when('/stat/insurance', {
          template: '<stat-insurance></stat-insurance>',
        })
        .when('/stat/vehicle/make', {
          template: '<stat-vehicle-make></stat-vehicle-make>',
        })
        .when('/stat/vehicle', {
          template: '<stat-vehicle-count></stat-vehicle-count>',
        })
        .when('/stat/laborcost', {
          template: '<stat-labor-cost></stat-labor-cost>',
        })
        .when('/stat/banner-clicks', {
          template: '<stat-banner-clicks></stat-banner-clicks>',
        })
        .when('/stat/insurancemti', {
          template: '<stat-insurance-mti></stat-insurance-mti>',
        })
        .when('/employees/by/area', {
          template: '<employees-by-area></employees-by-area>',
        })
        .when('/user/leave/reasons', {
          template: '<user-leave-reasons></user-leave-reasons>',
        })
        .when('/order/cancel/reasons', {
          template: '<orders-cancel-reasons></orders-cancel-reasons>',
        })
        .when('/duplicated/cars', {
          template: '<duplicated-car></duplicated-car>',
        })
        .when('/user/blacklist', {
          template: '<user-blacklist></user-blacklist>',
        })
        .when('/detailer/blacklist', {
          template: '<detailer-blacklist></detailer-blacklist>',
        })
        .when('/refundRequest', {
          template: '<refund-request></refund-request>',
        })
        .when('/modify/orders/:orderNo/goodsAndOptions', {
          template: '<orders-modify-goods></orders-modify-goods>',
        })
        .when('/refundPointList', {
          template: '<refund-point-list></refund-point-list>',
        })
        .when('/employees/add', {
          template: '<employee-add></employee-add>',
        })
        .when('/employees/:tbUserId', {
          template: '<employee-edit></employee-edit>',
        })
        .when('/event/point', {
          template: '<event-point></event-point>',
        })
        .when('/event/time_sale_wash_direct', {
          template: '<event-time-sale-wash-direct></event-time-sale-wash-direct>',
        })
        .when('/wash/cancel/request', {
          template: '<wash-cancel-request></wash-cancel-request>',
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/app/app.config.js